<template>
  <div class="mb-4">
    <h5 class="title">顔写真設定</h5>
    <div class="container">
      <div class="description mb-2 my-1">
        席次表に表示する顔写真を設定してください。
      </div>
      <div class="text-center">
        <icon :guest="guest" />
      </div>
      <div class="form-group mt-2 mb-4">
        <label class="">
          <span class="bg-dark text-white p-1">写真を選択</span>
          <input type="file" @change="attachIcon" accept="image/png, image/gif, image/jpeg" />
          <span>{{this.isIconAttached ? this.smallImage.name : "選択されていません"}}</span>
        </label>
      </div>
      <div class="my-1">
        <button
          type="button"
          class="btn btn-green btn-lg d-block w-100 rounded-pill"
          @click="submit">
          <i class="mio"> save </i>
          保存
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '../../guests/_icon'
const MAX_WIDTH = 320
const MAX_HEIGHT = 320
export default {
  components: { Icon },
  props: ['guest'],
  data() {
    return {isIconAttached: false, icon: this.guest.icon, smallImage: null}
  },
  methods: {
    submit() {
      if (!this.isIconAttached) {
        alert('アイコン画像を設定してください')
        return
      }
      const values = {icon: this.smallImage}
      this.$emit('submit', { guest: values })
    },
    attachIcon(e) {
      const files = e.target.files
      const file = files[0]
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = (e) => {
        const img = new Image()
        img.onload = () => {
          let sx
          const sy = 0
          let sw
          let sh
          if (img.width > img.height) {
            sx =  (img.width - img.height) * 0.5
            sw = img.height
            sh = img.height
          }else{
            sx = 0
            sw = img.width
            sh = img.width
          }
          const canvas = document.createElement('canvas')
          canvas.width = MAX_WIDTH
          canvas.height = MAX_HEIGHT
          const ctx = canvas.getContext('2d')
          ctx.drawImage(img, sx, sy, sw, sh, 0, 0, MAX_WIDTH, MAX_HEIGHT)
          canvas.toBlob((blob) => {
            const imageFile = new File([blob], file.name, {
              type: file.type,
              lastModified: Date.now()
            })
            this.smallImage = imageFile
            this.isIconAttached = true
          }, file.type, 1)
        }
        img.src = e.target.result
      }
    }
  }
}
</script>

<style scoped>
.description {
  color: rgb(115, 115, 115);
  font-size: 12.8px;
}
label input {
  display: none;
}
</style>
